var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('DataTable',{attrs:{"headers":_vm.tableHeaders,"items":_vm.formattedData,"items-per-page":999,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }